import React from 'react'
import Icon from '../icon/Icon'

export const swiperConfig = {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true
  },
  slidesPerView: 1
}

export const swiperLazyConfig = {
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
    loadOnTransitionStart: true
  }
}

export const swiperAutoViewConfig = {
  pagination: false,
  slidesPerView: 'auto',
  freeMode: true
}

export const buildImageSwiperConfig = {
  preventClicks: false,
  preventClicksPropagation: false,
  watchSlidesProgress: true,
  breakpoints: {
    1040: {
      allowTouchMove: false
    },
    320: {
      allowTouchMove: true
    }
  }
}

export const virtualizeConfig = {
  'virtual': {
    addSlidesAfter: 0,
    addSlidesBefore: 0,
    initialSlide: 0
  }
}

const updateSaveButton = () => {
  // eslint-disable-next-line no-unused-expressions
  window?.MyAD && window.MyAD?.renderBookmarkLinks()
}

export const goNext = (swiper, updateButtons, goToSlideNumber) => {
  if (Object.keys(swiper).length) {
    if (updateButtons) {
      swiper.slideTo(swiper.activeIndex + goToSlideNumber)
      updateButtons({ isEnd: swiper.isEnd, isBeginning: swiper.isBeginning })
    } else {
      if (swiper.isEnd) {
        swiper.slideTo(0)
      } else {
        swiper.slideNext()
      }
    }
  }
  updateSaveButton()
}

export const goPrev = (swiper, updateButtons, goToSlideNumber) => {
  if (Object.keys(swiper).length) {
    if (updateButtons) {
      swiper.slideTo(swiper.activeIndex - goToSlideNumber)
      updateButtons({ isEnd: swiper.isEnd, isBeginning: swiper.isBeginning })
    } else {
      if (swiper.isBeginning) {
        swiper.slideTo(swiper.slidesGrid.length - 1)
      } else {
        swiper.slidePrev()
      }
    }
  }
  updateSaveButton()
}

export const renderPrevButton = (swiper, prevIcon, updateButtons, goToSlideNumber) => (
  <div className='ad-swiper__prev' onClick={() => goPrev(swiper, updateButtons, goToSlideNumber)}>
    <Icon svg={prevIcon} withoutHover />
  </div>
)

export const renderNextButton = (swiper, nextIcon, updateButtons, goToSlideNumber) => (
  <div className='ad-swiper__next' onClick={() => goNext(swiper, updateButtons, goToSlideNumber)}>
    <Icon svg={nextIcon} withoutHover />
  </div>
)